import localstorage from 'src/helper/localstorage'
import config from 'src/core/config'
import { history } from 'src/core/router'

export default function (nextState, replaceState, callback) {
  if (config.route.whiteList.indexOf(nextState.location.pathname) === -1 && !isMember()) { // 没有登录而且访问了受限页面
    const orderId = new URLSearchParams(nextState.location.search || '').get('order_id')
    const orderQuery = nextState.location.pathname === '/dashboard/tradeManage/order' && /^[1-9]\d*$/.test(orderId || '')
      ? `?order_id=${encodeURIComponent(orderId)}` : ''
    history.push(`/oauth/login/index${orderQuery}`)
  }
  callback()
}

function isMember() {
  const userInfo = localstorage.get('userToken') || ''
  if (userInfo && userInfo!='') {
    return true
  }else{
    return false
  }
}


// WEBPACK FOOTER //
// ./core/oauth.js